var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"ok",rawName:"v-ok:enter",arg:"enter"}],ref:"main",attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"beforeinput":_vm.mask,"input":_vm.set}})
}
var staticRenderFns = []

export { render, staticRenderFns }